import React, { useEffect, useRef } from "react";
import { IoCloseSharp } from "react-icons/io5";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useDispatch, useSelector } from "react-redux";
import {
  selectGeneral,
  setShowFullscreenImage,
} from "../../redux/slices/generalSlice";
const FullScreenImage = ({ img }) => {
  const { showFullscreenImage } = useSelector(selectGeneral);
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const handleClose = () => {
    dispatch(setShowFullscreenImage(false));
  };
  useOutsideClick(modalRef, handleClose, null, showFullscreenImage);

  useEffect(() => {
    if (showFullscreenImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showFullscreenImage]);
  return (
    <div className="w-full z-50 flex  items-center fixed left-0 right-0 top-0 bottom-0 popup-bg ">
      <div className="w-full h-full flex flex-col">
        <div className=" w-full h-full flex justify-center items-center text-center ">
          <div
            className={`w-11/12 ${
              img ? "h-[calc(100vh-100px)]" : "h-auto"
            }  flex justify-center items-center overflow-hidden rounded-2xl`}
          >
            <div className="rounded-2xl overflow-hidden  justify-center items-center w-full h-full  flex relative">
              <div className="relative h-fit  lg:h-full flex " ref={modalRef}>
                <button
                  onClick={handleClose}
                  className="h-fit absolute top-3 right-3 bg-[#ffffffb9] backdrop-blur-md p-1.5 rounded-full"
                >
                  <IoCloseSharp color="#454545" size={30} />
                </button>{" "}
                <img
                  src={img}
                  alt="img"
                  className="rounded-2xl object-cover "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullScreenImage;
